import { render, staticRenderFns } from "./ServiceDeliveryForm.vue?vue&type=template&id=5394b9d0&"
import script from "./ServiceDeliveryForm.vue?vue&type=script&lang=js&"
export * from "./ServiceDeliveryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports